export default {

    newAsset: 'Agregar Activo',
    relatedAssets: 'Activos Relacionados',
    noAssetsCategories: 'No hay Categorías de Activos',
    noAsset: 'El activo no existe',
    noAssets: 'No hay activos',
    assetsMenu: 'Gestión de Activos',
    assetFromTemplate: 'Activo desde Plantilla',
    noAssetsCategory: { single: 'No hay Categoría de Activo', plural: 'No hay Categorías de Activos'},
    selectAssetFromTemplate: 'Selecciona los activos existentes que tienen relación con tu organización y las vulnerabilidades y amenazas que apliquen',
    assetDescription: 'representa cualquier recurso valioso dentro de tu organización que debe ser protegido. Puede ser un sistema, una base de datos, información confidencial, infraestructura tecnológica o incluso el conocimiento de tus empleados.',
    assetCreationMessage: '¡Ha llegado la hora de agregar tus activos!',
    assetGuide: ' que incluye vulnerabilidades y amenazas predeterminadas. Si prefieres agregar tus propios activos más adelante, simplemente haz clic en ',
    selectAssets: 'Para comenzar, puedes seleccionar activos desde nuestra',
    noDefaultAssets: 'sin activos por defecto',
    saveAssets: 'Guardar Activos',
    goToAssetCreation: 'Ir a la creación de activos',
    assetsManagement: 'Gestión de Activos',
    assets: 'Activos',
    asset: { single: 'Activo', plural: 'Activos'},
    assetCategory: { single: 'Categoría del Activo', plural: 'Categorías de Activos'},
    noAssetCategory: { single: 'Categoría de Activo no encontrada', plural: 'Categorías de Activos no encontradas'},
    noRegisteredAssets: 'Aún no tienes activos registrados',
    importAssetsOrUseTemplate: 'Puedes importar activos desde un archivo CSV o agregarlos utilizando nuestra plantilla prediseñada.',
    importExcelAssets: 'Quiero importar activos con una plantilla',
    imReadyAssets: 'Quiero agregar mis activos manualmente',
    exploreAssetsTemplate: 'Quiero elegir activos de una lista',
    createNewAsset: 'Crear nuevo activo',
    assetTypeNotFound: { single: 'Tipo de Activo no encontrado', plural: 'Tipos de Activo no encontrados'},
    assetType: { single: 'Tipo de Activo', plural: 'Tipos de Activo'},
    critical: 'Crítico',
    notCritical: 'No Crítico',
    noDefined: 'No Definido',
    assetTemplate: 'Plantilla de Activo del Sistema',
    addAssetFromTemplate: 'Agregar Activo desde Sistema',
    assetCategoryTooltip: 'Las categorías permiten diferenciar un activo por diferentes subtipos.',
    informationClassificationTooltip: 'Esta clasificación es ideal para entidades públicas. Permite diferenciar la información que contiene el activo según si es clasificada, pública o reservada.',
    informationClassification: { single: 'Clasificación de Información', plural: 'Clasificaciones de Información'},
    informationClassificationNotFound: { single: 'Clasificación de Información no encontrada', plural: 'Clasificaciones de Información no encontradas'},
    informationClassificationPlaceHolder: 'Selecciona una clasificación de información',
    assetLocation: 'Ubicación del Activo',
    assetLocationTooltip: 'Ubicación física o lógica del activo.',
    assetLocationPlaceHolder: 'Selecciona una ubicación del activo',
    assetLocationNotFound: { single: 'Ubicación de Activo no encontrada', plural: 'Ubicaciones de Activo no encontradas'},
    custodianTooltip: 'Persona o entidad responsable de la administración, protección y control del activo dentro de la organización.',
    custodian: { single: 'Custodio', plural: 'Custodios' },
    custodianNotFound: { single: 'Custodio no encontrado', plural: 'Custodios no encontrados'},
    custodianPlaceholder: 'Selecciona un custodio',
    ownerTooltip: 'Persona o área de la organización que posee el activo.',
    owner: { single: 'Propietario', plural: 'Propietarios'},
    ownerNotFound: { single: 'Propietario no encontrado', plural: 'Propietarios no encontrados'},
    ownerPlaceholder: 'Selecciona un propietario',
    organizationalProcessTooltip: 'Área o proceso de la organización a la que está asociado el activo.',
    organizationalProcess: { single: 'Proceso Organizacional', plural: 'Procesos Organizacionales'},
    organizationalProcessNotFound: { single: 'Proceso organizacional no encontrado', plural: 'Procesos organizacionales no encontrados'},
    organizationalProcessPlaceholder: 'Selecciona un proceso organizacional',
    organizationalCategory: { single: 'Categoría de la empresa', plural: 'Categorías de la empresa' },
    organizationalCategoryNotFound: { single: 'Categoría de empresa no encontrada', plural: 'Categorías de empresa no encontradas'},
    organizationalCategoryPlaceholder: 'Selecciona una categoría de empresa',
    evidenceLabel: 'Evidencia',
    evidenceEmpty: 'No hay archivos asociados',
    personalDataQuestion: '¿El activo contiene datos personales?',
    clickToUpload: 'Haz clic aquí para cargar tus archivos',
    editAsset: 'Editar Activo',
    saveAsset: 'Guardar Activo',
    assetsCategoryTooltip: 'Las categorías permiten diferenciar un activo por diferentes subtipos.',
    assetsSensitivityTooltip: 'Selecciona la clasificación según la sensibilidad de la información.',
    assetCustodianTooltip: 'Persona o entidad responsable de la administración, protección y control del activo dentro de la organización.',
    assetOwnerTooltip: 'Persona o área de la organización que posee el activo.',
    assetRelationshipGuide: 'Relacionar activos te permitirá identificar cómo se relacionan y afectan entre sí, facilitando la gestión de riesgos.',
    assetCatalogMenu: 'Catálogo de Activos del Sistema',
    assetCriticality: 'Criticidad del Activo',
    criticalAsset: 'Activo Crítico',
    notSure: 'No estoy seguro',
    criticalDetailsPlaceholder: '¿Por qué se considera crítico este activo?, ¿Quiénes lo usan? (0/500)',
    securityRequirements: 'Requerimientos de Seguridad',
    assetImpactFactor: 'Factor de Impacto del Activo',
    assetImpactFactorTooltip: 'Selecciona los factores de impacto del activo que aplican según su criticidad.',
    criticalDetailsTooltip: 'Describe por qué este activo es considerado crítico para la organización, quiénes dependen de él y cuál sería el impacto si fallara.',
    securityRequirementsTooltip: 'Ingresa una descripción para al menos un requerimiento de seguridad que aplique a este activo (confidencialidad, integridad o disponibilidad).',
    activate: 'Activar',
    createNewUbicationActive: 'Crear nueva ubicación de activo',
    createNewCustodian: 'Crear nuevo custodio',
    createNewOwner: 'Crear nuevo propietario',

};

